/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {CCInbox, MessageInfo_GetUnread, MessageWithStatus} from "@app/ir-q-app-common/types/message-api";
import {DB_Message, MessageStatuses} from "@app/ir-q-app-common/types/message";
import {COLORS} from "@res/colors";
import {FONTS} from "@res/fonts";
import * as React from "react";
import {useContext} from "react";
import {ICONS} from "@res/icons";
import {IconStatus} from "../../../../utils/IconStatus";
import {backgroundCell, InboxTable} from "../InboxTable";
import {ContactsContext} from "../ContactsContext";

type Props = {
    chat: CCInbox | MessageInfo_GetUnread
    onClick: () => void
    isOpen: boolean
    getUnreadMessages: () => number
}

export const LastMessage = (props: Props) => {
    const {contacts} = useContext(ContactsContext)

    const getAudiMessageDescription = (text?: string) => {
        if (!text)
            return 'Audio Message'

        return reformatMessageSnippet(`Transcript: ${text}`);
    };

    const reformatMessageSnippet = (text: string | undefined, maxLength = 100) => {
        if (!text)
            return ""

        if (text.length < maxLength)
            return text;

        return text.substr(0, maxLength) + "...";
    };

    const getDisplayText = (_lastMessage?: DB_Message<any>) => {
        switch (_lastMessage?.type) {
            case 'audio':
                return getAudiMessageDescription(_lastMessage.data.text);
            case 'text':
                return reformatMessageSnippet(_lastMessage.data.text);
            case 'video':
                return 'Video Message'
            case 'image':
                return 'Image Message'
        }
        return '...';
    };

    const getIcon = (message?: MessageWithStatus) => {
        if (!message)
            return <div/>

        const senderContact = contacts[message.senderId];

        switch (message.type) {
            case "audio":
                return <div className="ll_v_r" style={{paddingLeft: 10}}>
                    <div className="ll_h_c" style={{marginLeft: 7, justifyContent: "space-between"}}>
                        {senderContact && senderContact.contactType === "agentUser" && <div style={{marginRight: 10}}>
                            <IconStatus status={message.status.status}/>
                        </div>}
                        {ICONS.icon_voice(COLORS.neutral_text_dark_2, 16)}
                    </div>
                </div>;
            default:
                if (senderContact && senderContact.contactType === "agentUser")
                    return <div/>

                return <div className="ll_v_r" style={{paddingLeft: 10}}>
                    <div className="ll_h_c" style={{width: 24, height: 24}}>
                        <div style={{marginLeft: 7, boxSizing: "border-box"}}>
                            <IconStatus status={message.status.status}/>
                        </div>
                    </div>
                </div>;
        }
    }

    const chat = props.chat;
    const unreadMessages = props.getUnreadMessages();
    const lastMessage = chat.lastMessage;
    // Then give it proper formatting.
    const displayedText = getDisplayText(lastMessage);
    const icon = getIcon(lastMessage);

    let backgroundColor = "transparent";
    if (unreadMessages)
        backgroundColor = "#fffaf0";
    if (props.isOpen)
        backgroundColor = COLORS.primary_light_blue;

    return <div className={`ll_h_c ${backgroundCell(backgroundColor)}`} onClick={() => props.onClick()}>
        {icon}
        {InboxTable.rowStyle(displayedText, unreadMessages > 0,
            lastMessage?.status.status.toUpperCase() === MessageStatuses.FAILED.toUpperCase())}
        {lastMessage?.data.choices && <div style={{
            display: "flex",
            height: 21,
            padding: "0 3px 0 7px",
            objectFit: "contain",
            borderRadius: 15.5,
            backgroundColor: lastMessage.status.status.toUpperCase() === MessageStatuses.READ.toUpperCase() ? COLORS.macaroni_and_cheese : "rgb(188 188 188)",
            alignItems: "center"
        }}>
            <div style={{
                width: 7,
                height: 7,
                borderRadius: 10,
                marginRight: 6,
                backgroundColor: COLORS.white
            }}/>
            {FONTS.reg_12("Customer reply required", {color: COLORS.white})}
        </div>}
    </div>;


}
